import React from 'react';

import Box from '../Box/Box';
import Icon from './Icon';
import { TIconCompoundProps } from './types';

const IconCompound = ({ name, color, ...rest }: TIconCompoundProps) => {
  return (
    <Box {...rest} as="div" name="IconCompound">
      <Icon name={name} color={color} />
      <Icon name="verified" color="signal-success-default" />
    </Box>
  );
};

export default IconCompound;
